module.exports = __webpack_public_path__ + "img/img_5.1e38a40c.png";